const UNIQUE_TEACHER_PARTICIPANT_ACTION_TYPE = {
  GET_UNIQUE_TEACHER_PARTICIPANTS: 'GET_UNIQUE_TEACHER_PARTICIPANTS',
  GET_UNIQUE_TEACHER_PARTICIPANT: 'GET_UNIQUE_TEACHER_PARTICIPANT',
  UPDATE_UNIQUE_TEACHER_PARTICIPANT: 'UPDATE_UNIQUE_TEACHER_PARTICIPANT',
  DELETE_UNIQUE_TEACHER_PARTICIPANT: 'DELETE_UNIQUE_TEACHER_PARTICIPANT',
  REFRESH_UNIQUE_TEACHER_PARTICIPANTS: 'REFRESH_UNIQUE_TEACHER_PARTICIPANTS'
}
export default UNIQUE_TEACHER_PARTICIPANT_ACTION_TYPE
